import { FC, ReactElement } from "react"
import Tooltip from "../atoms/ToolTip"

interface DisabledActionTooltipProps {
  disabled: boolean
  text: string
  children: ReactElement
}

const DisabledActionTooltip: FC<DisabledActionTooltipProps> = ({
  disabled,
  text,
  children,
}) => {
  if (!disabled) {
    return children
  }

  return (
    <Tooltip text={text}>
      <span
        style={{ display: "inline-flex" }}
        tabIndex={0}
        aria-disabled="true"
      >
        {children}
      </span>
    </Tooltip>
  )
}

export default DisabledActionTooltip
